import React from "react"
import ReactGA from "react-ga"

import rightArrowGreenImg from "../../images/new-pricing/right-arrow-green.svg"
import calenderImg from "../../images/new-pricing/calendar.png"
import video1Img from "../../images/new-pricing/video1.png"
import video2Img from "../../images/new-pricing/video2.png"
import messagesImg from "../../images/new-pricing/messages.png"
import startImg from "../../images/new-pricing/star.png"
import footerCurveImage from "../../images/new-pricing/footer-curve.svg"

export default function Demo({ activeTab, page, toggleHowSignupModal, toggleSendInvoiceModal }) {

  const bookDemoBtnClick = (btn) => {
    ReactGA.event({
      category: `${page}_${btn}`,
      action: `${page}_${btn}`,
    })
  }

  const howSignupClick = () => {
    ReactGA.event({
      category: `${page}_How to sign up`,
      action: `${page}_How to sign up`,
    })
    toggleHowSignupModal();
  }

  const sendInvoiceClick = () => {
    ReactGA.event({
      category: `${page}_Send your 1st e-invoice`,
      action: `${page}_Send your 1st e-invoice`,
    })
    toggleSendInvoiceModal();
  }

  return (
    <div className={`demo mx-auto relative sm:mt-0 mt-5 ${activeTab === 2 && "-mt-45p"}`}>
      <div className="absolute curve">
        <img src={footerCurveImage} />
      </div>
      <div className={`flex justify-between sm:flex-row flex-col ${activeTab === 1 && 'justify-content-center sm:pr-12'} container`}>
        <div>
          <div className='cursor-pointer' onClick={howSignupClick}>
            <img src={video1Img} className="mx-auto w-16" />
          </div>
          <div className="title text-18 text-mind font-bold text-center my-5">
            Video Resources
          </div>
          <div className="text-neutral-3 text-15 text mx-auto mb-5">
            How to sign up
          </div>
          <div className="text-mind font-medium flex justify-content-center cursor-pointer" onClick={howSignupClick}>
            Watch a video
            <img src={rightArrowGreenImg} className="ml-2" />
          </div>
        </div>
        <div className='sm:mx-20 sm:my-0 my-12'>
          <div className='cursor-pointer' onClick={sendInvoiceClick}>
            <img src={video2Img} className="mx-auto w-16" />
          </div>
          <div className="title text-18 text-mind font-bold text-center my-5">
            Video Resources
          </div>
          <div className="text-neutral-3 text-15 text mx-auto mb-5">
            Send your 1st e-invoice
          </div>
          <div className="text-mind font-medium flex justify-content-center cursor-pointer" onClick={sendInvoiceClick}>
            Watch a video
            <img src={rightArrowGreenImg} className="ml-2" />
          </div>
        </div>
        <div>
          <div className='cursor-pointer' onClick={() => bookDemoBtnClick('Book A Demo')}>
            <img src={calenderImg} className="mx-auto w-16" />
          </div>
          <div className="title text-18 text-mind font-bold text-center my-5">
            We are a click away!
          </div>
          <div className="text-neutral-3 text-15 text mx-auto mb-5">
            Get in touch wit us today
          </div>
          <a className="text-mind font-medium flex justify-content-center cursor-pointer"
             href="https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus" onClick={() => bookDemoBtnClick('Book A Demo')}>
            Book a demo
            <img src={rightArrowGreenImg} className="ml-2" />
          </a>
        </div>
        {activeTab === 2 &&
        <div className='sm:my-0 my-12'>
          <div>
            <img src={messagesImg} className="mx-auto w-16" />
          </div>
          <div className="title text-18 text-mind font-bold text-center my-5">
            Do you still need more information?
          </div>
          <div className="text-neutral-3 text-15 text mx-auto mb-5">
            We can help answer any questions you may have, and even walk you through setting up your LUCA Plus account
          </div>
          <a className="text-mind font-medium flex justify-content-center cursor-pointer"
             href="https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus" onClick={() => bookDemoBtnClick('Get In Touch')}>
            Get in touch
            <img src={rightArrowGreenImg} className="ml-2" />
          </a>
        </div>}
        {activeTab === 2 &&
        <div>
          <div>
            <img src={startImg} className="mx-auto w-16" />
          </div>
          <div className="title text-18 text-mind font-bold text-center my-5">
            Join our FREE Partner Program
          </div>
          <div className="text-neutral-3 text-15 text mx-auto mb-5">
            Get in touch with Leo Huang, Partner Program Account Manager to get you LUCA Plus ready!
          </div>
          <a className="text-mind font-medium flex justify-content-center cursor-pointer"
             href="https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus" onClick={() => bookDemoBtnClick("I\'m a Bookkeeper or Accountant")}>
            I'm a bookkeeper or accountant
            <img src={rightArrowGreenImg} className="ml-2" />
          </a>
        </div>}
      </div>
    </div>
  )
}
